import React, { Dispatch, useState } from "react";
import { Label, Select } from "uxp/components";
import useFigma from "../figma/useFigma";
import { IUIPropertyDefinition } from "../common";

interface IOptions {
    showCategoryTitle?: boolean
    data: Array<{ id: string, name: string }>,
    selected?: string
}

export const DropdownProperty = (title: string, props: string, options: IOptions): IUIPropertyDefinition<string> => {

    const { showCategoryTitle, data, selected } = options;

    return {
        defaults: props,
        render: (props: any) => {

            const [_selected, setSelected] = useState(selected)
            const handleChange = (value: any) => {
                setSelected(value)
                props.onChange(value)
            }

            return (
                <div className="wd-prop-item">

                    {!!showCategoryTitle && <div className='wd-prop-item-title'>{title}</div>}

                    <div className='wd-prop-item-editor'>
                        <Label>{title}</Label>

                        <Select
                            isValid={(data && data.length > 0) ? null : false}
                            options={data}
                            labelField={"name"}
                            valueField={"id"}
                            onChange={handleChange}
                            selected={_selected}
                        />
                    </div>

                </div>
            )
        }
    }
}